import { render, staticRenderFns } from "./ParentVerticalNavMenu.vue?vue&type=template&id=7ca80dc8&"
import script from "./ParentVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./ParentVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./ParentVerticalNavMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ParentVerticalNavMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports